import React, { Component } from 'react';
import styles from './styles.scss';

class Blank extends Component 
{
  constructor(props){
    super(props);
    this.state = {
    };
  }

  render()
  {
    return (
      <div className={styles.page_container}>
        <h1>
          目前暫無資料，請洽物管
        </h1>
        <p>
          (如貴社區未使用社區雲，煩請管委會與我們聯繫)
        </p>
      </div>
    );
  }
}

export default Blank;


// WEBPACK FOOTER //
// ./src/views/Blank/Blank.js